import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { HTTP } from "../api/http-common";
import Swal from "sweetalert2";
import { MultiSelect } from "react-multi-select-component";
import { isValidEmail } from "./common";
import { loadStripe } from '@stripe/stripe-js';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHED_KEY);


function MembershipModal({ showModal, setShowModal, formData, setFormData }) {
  const [emailError, setEmailError] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const styles = {
    modal: {
      content: {
        padding: '30px',
        borderRadius: '10px',
        backgroundColor: '#fff',
        maxWidth: '600px',
        margin: 'auto',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        position: 'absolute',
        maxHeight: '350px',
      },
    },
  }
  const resetValidationErrors = () => {
    setEmailError('')
  }
  const validateField = () => {
    resetValidationErrors();

    let checked = true;

    if (formData.email === '') {
      setEmailError('Please enter email address');
      if (checked) {
        checked = false;
      }
    }
    else if (!isValidEmail(formData.email)) {
      setEmailError('Invalid email.');
      if (checked) {
        checked = false;
      }
    } else if (formData.email.length > 100) {
      setEmailError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }

    return checked;
  };

  const handleVerification = async (event) => {
    event.preventDefault();

    if (validateField()) {
      try {
        // Optional: if using token-based auth, uncomment and set token
        // const access_token = localStorage.getItem("access_token");
        let config = {
          // headers: { "Content-Type": "application/json", token: access_token },
        };

        const response = await HTTP.post("/stripe/isregistered", formData, config);

        console.log(response.data.content)

        if (response.status === 200) {
          localStorage.setItem('payment_session_id',response.data.content);
          const stripe = await stripePromise;
          await stripe.redirectToCheckout({ sessionId: response.data.content });

          // // Optionally:
          setShowModal(false);
        }
      } catch (error) {
        console.log(error)
        if (error.response && error.response.status === 406) {
          Swal.fire({
            title: 'Error!',
            text: error.response.data.detail,
            confirmButtonText: 'Ok'
          });
        } else {
          Swal.fire("Error", "There was an unexpected error.", "error");
        }
      }
    }
  };
  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        contentLabel="Add"
        style={styles.modal}
      >
        <div className="flex flex-col space-y-1.5 text-center sm:text-left">
          <h2 className="text-lg sm:text-xl font-semibold leading-none tracking-tight">
            Confirm registered email and pay
          </h2>
          <p className="text-sm text-muted-foreground">&nbsp;</p>
        </div>

        <form
          className="space-y-6 custom-overlay-position mt-4"
          onSubmit={handleVerification}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Email Input */}
            <div className="space-y-2 col-span-2">
              <label
                htmlFor="email"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Registered Email:
              </label>
              <div className="relative space-y-1">
                <input
                  className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                  placeholder="Enter your registered email"
                  name="email"
                  id="email"
                  aria-describedby="email-description"
                  aria-invalid="false"
                  value={formData.email}
                  onChange={handleChange}
                />
                {emailError && (
                  <span className="text-sm text-red-500">{emailError}</span>
                )}
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <button
              className="inline-flex items-center justify-center gap-2 text-sm font-medium transition-colors focus:outline-none focus:ring-1 focus:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow px-4 py-2 w-full sm:w-auto bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg respomsive-button-size"
              type="submit"
            >
              Confirm & Pay ${formData.plan_amount} for {formData.plan_type}
            </button>

            <button
              className="inline-flex items-center justify-center gap-2 text-sm font-medium transition-colors focus:outline-none focus:ring-1 focus:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow px-4 py-2 w-full sm:w-auto bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg respomsive-button-size"
              type="button"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </form>
      </Modal>

    </>
  )
}

export default MembershipModal